<template>
  <div id="Sale" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 fixed-t">
        <div class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 bb1">
          <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
          <div class="col-6 t-c color-primary"><span class="f24 fw">D</span>etalle</div>
          <div class="col-3 t-r f22 pr3"></div>
        </div>
        <div class="col-12 color-muted lh22 f14">
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10">
          <div class="col-6">Doc <span class="color-black fw f18">#{{ pageData.sale_no }}</span></div>
          <div class="col-6 t-r">{{ pageData.update_time }}</div>
        </div>
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10">
          <div class="col-12">RIF/CI: <span class="fw color-black">{{ pageData.client_lic }}</span></div>
        </div>
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10">
          <div class="col-12">RAZON SOCIAL: <span class="fw color-black">{{ pageData.client_name }}</span></div>
        </div>
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10">
          <div class="col-12"><span class="fw color-black">{{ pageData.extension_name }}</span> / Cajera: <span class="fw color-black">{{ pageData.cashier_name }}</span>  / Vendedor: <span class="fw color-black">{{ pageData.salesman_name }}</span></div>
        </div>
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt5 pb5 fw f14 color-black">
          <div class="col-6">Descripción</div>
          <div class="col-6 t-r">Total</div>
        </div>
      </div>
    </div>
    <div class="h25"></div>
    <div class="col-12 pt3 pb10 bg-color1" style="overflow-y: auto;">
      <div class="col-12 color-muted" v-for="(detail,detail_i) in dataList" v-bind:key="detail_i">
        <div class="col-12 bg-color-white pl10 pr10 pt5 pb2">
          <div class="col-6">[ <span class="fw">{{fun.formatMoney(detail.quantity,0)}}</span> ] x <span v-if="$store.state.pos.currency_on == 1">{{ fun.formatMoney(detail.product_price_ex1,2) }}</span> <span v-else>{{ fun.formatMoney(detail.product_price,2) }}</span> </div>
          <div class="col-6 t-r" v-if="$store.state.pos.currency_on == 1">{{ fun.formatMoney(detail.product_price_ex1 * detail.quantity * detail.discount, 2) }}</div>
          <div class="col-6 t-r" v-else>{{ fun.formatMoney(detail.product_price * detail.quantity * detail.discount, 2) }}</div>
        </div>   
        <div class="col-12 bg-color-white pl10 pr10 pt2 pb5 bb1 f14 uppercase">
          {{ detail.product_name }} <span v-if="detail.tax == 0" class="fw">(E)</span><span v-else-if="detail.tax == 0.16" class="fw">(G)</span>
        </div>     
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10 f14 color-muted">
        <div class="col-6">EXENTO (E)</div>
        <div class="col-6 t-r uppercase" v-if="$store.state.pos.currency_on == 1">{{ fun.formatMoney(pageData.total_0_ex1,2) }}</div>
        <div class="col-6 t-r uppercase" v-else>{{ fun.formatMoney(pageData.total_0,2) }}</div>
      </div>
      <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10 f14 color-muted">
        <div class="col-6">BI G({{ pos.tax_1 * 100 }}.00%)</div>
        <div class="col-6 t-r uppercase" v-if="$store.state.pos.currency_on == 1">{{ fun.formatMoney(pageData.total_1_ex1,2) }}</div>
        <div class="col-6 t-r uppercase" v-else>{{ fun.formatMoney(pageData.total_1,2) }}</div>
      </div>
      <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10 f14 color-muted">
        <div class="col-6">IVA G({{ pos.tax_1 * 100 }}.00%)</div>
        <div class="col-6 t-r uppercase" v-if="$store.state.pos.currency_on == 1">{{ fun.formatMoney(pageData.total_iva_1_ex1,2) }}</div>
        <div class="col-6 t-r uppercase" v-else>{{ fun.formatMoney(pageData.total_iva_1,2) }}</div>
      </div>
      <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10 f14 color-muted" v-if="pageData.total_2 > 0">
        <div class="col-6">BI R({{ pos.tax_2 * 100 }}.00%)</div>
        <div class="col-6 t-r uppercase" v-if="$store.state.pos.currency_on == 1">{{ fun.formatMoney(pageData.total_2_ex1,2) }}</div>
        <div class="col-6 t-r uppercase" v-else>{{ fun.formatMoney(pageData.total_2,2) }}</div>
      </div>
      <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10 f14 color-muted" v-if="pageData.total_2 > 0">
        <div class="col-6">IVA R({{ pos.tax_2 * 100 }}.00%)</div>
        <div class="col-6 t-r uppercase" v-if="$store.state.pos.currency_on == 1">{{ fun.formatMoney(pageData.total_iva_2_ex1,2) }}</div>
        <div class="col-6 t-r uppercase" v-else>{{ fun.formatMoney(pageData.total_iva_2,2) }}</div>
      </div>
      <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10 f14 color-muted">
        <div class="col-6 f18">TOTAL</div>
        <div class="col-6 t-r uppercase f18 color-black fw" v-if="$store.state.pos.currency_on == 1">{{ fun.formatMoney(pageData.total_ex1,2) }}</div>
        <div class="col-6 t-r uppercase f18 color-black fw" v-else>{{ fun.formatMoney(pageData.total,2) }}</div>
      </div>
    </div>
    <div class="col-12 mt10">
      <div class="col-12 color-muted f14 lh40"><i class="iconfont icon-arrow-right-filling color-primary"></i> FORMAS DE PAGO</div>
      <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10 f14 color-muted" v-for="(payment,payment_i) in payment_list" v-bind:key="payment_i">
        <div class="col-6">{{payment.method_name}}</div>
        <div class="col-6 t-r uppercase">{{ fun.formatMoney(payment.exchange,2) }}</div>
      </div>
    </div>
    <div class="col-12 mt10" v-if="changer_list.length > 0">
      <div class="col-12 color-muted f14 lh40"><i class="iconfont icon-arrow-right-filling color-primary"></i> CAMBIO</div>
      <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10 f14 color-muted" v-for="(changer,changer_i) in changer_list" v-bind:key="changer_i">
        <div class="col-6">{{changer.method_name}}</div>
        <div class="col-6 t-r uppercase color-danger">-{{ fun.formatMoney(changer.exchange,2) }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Sale',
  data () {
    return {
      id: this.$route.query.id,
      pageData: {},
      dataList: [],
      pos: {},
      payment_list: [],
      changer_list: [],
    }
  },
  created: function () {
    this.get_pageData();
  },
  methods: {
    get_pageData() {
      var post_data = {};
      post_data.id = this.id;
      this.post(this.api_url + 'manage/sale', post_data).then((res)=>{
        if(res.status == 1){
          this.pageData = res.data.sale;
          this.dataList = res.data.sale_detail;
          this.pos = res.data.pos;
          this.payment_list = res.data.payments;
          if(res.data.changers){
            this.changer_list = res.data.changers;
          }
        }else{
          this.pageData = {}
          this.dataList = []
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/Sale.vue